import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const SupportPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('faq');
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    category: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Email ile form gönderimi
    const emailBody = `
Adı Soyadı: ${contactForm.name}
E-posta: ${contactForm.email}
Telefon: ${contactForm.phone}
Kategori: ${contactForm.category}

Mesaj:
${contactForm.message}
    `;
    
    const mailtoLink = `mailto:destek@taxicim.com.tr?subject=Destek Talebi - ${contactForm.category}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink;
  };

  const faqData = [
    {
      question: "Nasıl kayıt olabilirim?",
      answer: "Taxicim'e kayıt olmak için ana sayfadan 'Yolcu Kayıt Ol' veya 'Şoför Kayıt Ol' butonlarına tıklayın. Gerekli bilgileri doldurun ve üyelik planınızı seçin."
    },
    {
      question: "Taksi nasıl çağırabilirim?",
      answer: "Giriş yaptıktan sonra yolcu panelinden kalkış ve varış noktanızı belirleyin. Sistem size en yakın müsait şoförü bulacaktır."
    },
    {
      question: "Ödeme nasıl yapabilirim?",
      answer: "Kredi kartı, banka kartı veya nakit ödeme seçeneklerini kullanabilirsiniz. Üyelik ödemeleri için güvenli ödeme sistemimizi kullanın."
    },
    {
      question: "Şoför olarak nasıl başvururum?",
      answer: "Şoför kayıt formunu doldurun, gerekli belgeleri yükleyin ve sözleşme tipinizi seçin. Onay sonrası hizmet vermeye başlayabilirsiniz."
    },
    {
      question: "Premium üyelik avantajları nelerdir?",
      answer: "Premium üyeler öncelikli hizmet, indirimli tarifeler, loyalite puanları ve özel müşteri desteği avantajlarından yararlanır."
    },
    {
      question: "Güvenlik önlemleriniz nelerdir?",
      answer: "Tüm şoförlerimiz doğrulanmış, araçlar sigortalı ve her yolculuk GPS ile takip edilir. 7/24 güvenlik destek hattımız mevcuttur."
    },
    {
      question: "İptal politikanız nasıldır?",
      answer: "Yolculuk başlamadan önce ücretsiz iptal edebilirsiniz. Şoför yola çıktıktan sonra iptal ücreti uygulanabilir."
    },
    {
      question: "Uygulama hangi şehirlerde hizmet veriyor?",
      answer: "İstanbul, Ankara, İzmir başta olmak üzere Türkiye'nin 20 büyük şehrinde hizmet veriyoruz. Sürekli yeni şehirler ekleniyor."
    }
  ];

  const supportCategories = [
    { id: 'account', name: 'Hesap İşlemleri', icon: '👤' },
    { id: 'booking', name: 'Rezervasyon', icon: '🚕' },
    { id: 'payment', name: 'Ödeme', icon: '💳' },
    { id: 'technical', name: 'Teknik Sorun', icon: '⚙️' },
    { id: 'driver', name: 'Şoför İşlemleri', icon: '🚗' },
    { id: 'other', name: 'Diğer', icon: '📞' }
  ];

  return (
    <div className="login-container">
      <div className="privacy-container">
        <button 
          onClick={() => navigate('/')}
          className="back-btn"
          style={{ marginBottom: '1rem' }}
        >
          ← Ana Sayfa
        </button>

        <div className="privacy-header">
          <h1>🛠️ Destek Merkezi</h1>
          <p>Size nasıl yardımcı olabiliriz? Her türlü sorununuz için buradayız!</p>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <div style={{ 
            display: 'flex', 
            gap: '0.5rem', 
            marginBottom: '3rem', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            background: '#f8f9fa',
            padding: '0.5rem',
            borderRadius: '20px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
          }}>
            <button 
              onClick={() => setActiveTab('faq')}
              style={{
                padding: '1rem 2rem',
                border: 'none',
                borderRadius: '15px',
                background: activeTab === 'faq' ? 'linear-gradient(135deg, #FFC107 0%, #FFB300 100%)' : 'transparent',
                color: activeTab === 'faq' ? '#fff' : '#666',
                cursor: 'pointer',
                fontWeight: activeTab === 'faq' ? '700' : '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: activeTab === 'faq' ? '0 4px 15px rgba(255, 193, 7, 0.3)' : 'none',
                transform: activeTab === 'faq' ? 'translateY(-2px)' : 'none'
              }}
            >
              📚 Sık Sorulan Sorular
            </button>
            <button 
              onClick={() => setActiveTab('contact')}
              style={{
                padding: '1rem 2rem',
                border: 'none',
                borderRadius: '15px',
                background: activeTab === 'contact' ? 'linear-gradient(135deg, #FFC107 0%, #FFB300 100%)' : 'transparent',
                color: activeTab === 'contact' ? '#fff' : '#666',
                cursor: 'pointer',
                fontWeight: activeTab === 'contact' ? '700' : '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: activeTab === 'contact' ? '0 4px 15px rgba(255, 193, 7, 0.3)' : 'none',
                transform: activeTab === 'contact' ? 'translateY(-2px)' : 'none'
              }}
            >
              📧 İletişim
            </button>
            <button 
              onClick={() => setActiveTab('emergency')}
              style={{
                padding: '1rem 2rem',
                border: 'none',
                borderRadius: '15px',
                background: activeTab === 'emergency' ? 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)' : 'transparent',
                color: activeTab === 'emergency' ? '#fff' : '#666',
                cursor: 'pointer',
                fontWeight: activeTab === 'emergency' ? '700' : '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: activeTab === 'emergency' ? '0 4px 15px rgba(220, 53, 69, 0.3)' : 'none',
                transform: activeTab === 'emergency' ? 'translateY(-2px)' : 'none'
              }}
            >
              🚨 Acil Durum
            </button>
          </div>

          {activeTab === 'faq' && (
            <div className="privacy-content">
              <section>
                <h2>💬 Sık Sorulan Sorular</h2>
                <div style={{ display: 'grid', gap: '1rem' }}>
                  {faqData.map((faq, index) => (
                    <details key={index} style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                      <summary style={{ fontWeight: '600', color: '#333', cursor: 'pointer', marginBottom: '0.5rem' }}>
                        {faq.question}
                      </summary>
                      <p style={{ margin: '0.5rem 0 0 0', color: '#666', lineHeight: '1.6' }}>
                        {faq.answer}
                      </p>
                    </details>
                  ))}
                </div>
              </section>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="privacy-content">
              <section>
                <h2>📞 İletişim Kanalları</h2>
                <div style={{ display: 'grid', gap: '1.5rem', marginBottom: '2rem' }}>
                  <div style={{ 
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%)', 
                    padding: '2rem', 
                    borderRadius: '15px', 
                    boxShadow: '0 8px 32px rgba(33, 150, 243, 0.1)',
                    border: '2px solid #e3f2fd',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <div style={{ 
                        background: '#2196F3', 
                        borderRadius: '50%', 
                        width: '50px', 
                        height: '50px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginRight: '1rem'
                      }}>
                        <span style={{ fontSize: '1.5rem' }}>📞</span>
                      </div>
                      <h3 style={{ margin: 0, color: '#1976d2' }}>Telefon Desteği</h3>
                    </div>
                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#1976d2', margin: '0.5rem 0' }}>
                      08502428876
                    </p>
                    <p style={{ color: '#666', margin: 0 }}>7/24 Kesintisiz Destek</p>
                  </div>

                  <div style={{ 
                    background: 'linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%)', 
                    padding: '2rem', 
                    borderRadius: '15px', 
                    boxShadow: '0 8px 32px rgba(76, 175, 80, 0.1)',
                    border: '2px solid #e8f5e8',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <div style={{ 
                        background: '#4caf50', 
                        borderRadius: '50%', 
                        width: '50px', 
                        height: '50px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginRight: '1rem'
                      }}>
                        <span style={{ fontSize: '1.5rem' }}>📧</span>
                      </div>
                      <h3 style={{ margin: 0, color: '#2e7d32' }}>E-posta Desteği</h3>
                    </div>
                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#2e7d32', margin: '0.5rem 0' }}>
                      destek@taxicim.com.tr
                    </p>
                    <p style={{ color: '#666', margin: 0 }}>Hızlı ve detaylı yanıt</p>
                  </div>

                  <div style={{ 
                    background: 'linear-gradient(135deg, #fff3e0 0%, #fef7e0 100%)', 
                    padding: '2rem', 
                    borderRadius: '15px', 
                    boxShadow: '0 8px 32px rgba(255, 152, 0, 0.1)',
                    border: '2px solid #fff3e0',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <div style={{ 
                        background: '#ff9800', 
                        borderRadius: '50%', 
                        width: '50px', 
                        height: '50px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginRight: '1rem'
                      }}>
                        <span style={{ fontSize: '1.5rem' }}>💬</span>
                      </div>
                      <h3 style={{ margin: 0, color: '#f57c00' }}>WhatsApp Desteği</h3>
                    </div>
                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#f57c00', margin: '0.5rem 0' }}>
                      0850 242 88 76
                    </p>
                    <p style={{ color: '#666', margin: 0 }}>Anında mesajlaşma</p>
                  </div>
                </div>

                <h3 style={{ 
                  color: '#333', 
                  marginBottom: '1.5rem',
                  fontSize: '1.5rem',
                  textAlign: 'center'
                }}>📝 Destek Talebi Oluştur</h3>
                <form onSubmit={handleSubmit} style={{ 
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)', 
                  padding: '2.5rem', 
                  borderRadius: '20px',
                  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #e0e0e0'
                }}>
                  <div style={{ display: 'grid', gap: '1rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div>
                        <label style={{ 
                          display: 'block', 
                          marginBottom: '0.8rem', 
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '0.95rem'
                        }}>Ad Soyad</label>
                        <input
                          type="text"
                          name="name"
                          value={contactForm.name}
                          onChange={handleInputChange}
                          required
                          style={{ 
                            width: '100%', 
                            padding: '1rem', 
                            border: '2px solid #e0e0e0', 
                            borderRadius: '12px',
                            fontSize: '1rem',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafafa'
                          }}
                          placeholder="Adınız Soyadınız"
                        />
                      </div>
                      <div>
                        <label style={{ 
                          display: 'block', 
                          marginBottom: '0.8rem', 
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '0.95rem'
                        }}>E-posta</label>
                        <input
                          type="email"
                          name="email"
                          value={contactForm.email}
                          onChange={handleInputChange}
                          required
                          style={{ 
                            width: '100%', 
                            padding: '1rem', 
                            border: '2px solid #e0e0e0', 
                            borderRadius: '12px',
                            fontSize: '1rem',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafafa'
                          }}
                          placeholder="ornek@email.com"
                        />
                      </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div>
                        <label style={{ 
                          display: 'block', 
                          marginBottom: '0.8rem', 
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '0.95rem'
                        }}>Telefon</label>
                        <input
                          type="tel"
                          name="phone"
                          value={contactForm.phone}
                          onChange={handleInputChange}
                          style={{ 
                            width: '100%', 
                            padding: '1rem', 
                            border: '2px solid #e0e0e0', 
                            borderRadius: '12px',
                            fontSize: '1rem',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafafa'
                          }}
                          placeholder="0555 000 00 00"
                        />
                      </div>
                      <div>
                        <label style={{ 
                          display: 'block', 
                          marginBottom: '0.8rem', 
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '0.95rem'
                        }}>Kategori</label>
                        <select
                          name="category"
                          value={contactForm.category}
                          onChange={handleInputChange}
                          required
                          style={{ 
                            width: '100%', 
                            padding: '1rem', 
                            border: '2px solid #e0e0e0', 
                            borderRadius: '12px',
                            fontSize: '1rem',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafafa',
                            cursor: 'pointer'
                          }}
                        >
                          <option value="">Kategori seçin</option>
                          {supportCategories.map(cat => (
                            <option key={cat.id} value={cat.name}>{cat.icon} {cat.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <label style={{ 
                        display: 'block', 
                        marginBottom: '0.8rem', 
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '0.95rem'
                      }}>Mesajınız</label>
                      <textarea
                        name="message"
                        value={contactForm.message}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        style={{ 
                          width: '100%', 
                          padding: '1rem', 
                          border: '2px solid #e0e0e0', 
                          borderRadius: '12px',
                          fontSize: '1rem',
                          transition: 'all 0.3s ease',
                          backgroundColor: '#fafafa',
                          resize: 'vertical',
                          fontFamily: 'inherit'
                        }}
                        placeholder="Sorununuzu detaylarıyla açıklayın..."
                      />
                    </div>

                    <button
                      type="submit"
                      style={{
                        background: 'linear-gradient(135deg, #FFC107 0%, #FFB300 100%)',
                        color: '#fff',
                        border: 'none',
                        padding: '1.2rem 2.5rem',
                        borderRadius: '15px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        fontSize: '1.1rem',
                        boxShadow: '0 8px 32px rgba(255, 193, 7, 0.3)',
                        transition: 'all 0.3s ease',
                        width: '100%',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 12px 40px rgba(255, 193, 7, 0.4)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(255, 193, 7, 0.3)';
                      }}
                    >
                      📤 Destek Talebi Gönder
                    </button>
                  </div>
                </form>
              </section>
            </div>
          )}

          {activeTab === 'emergency' && (
            <div className="privacy-content">
              <section style={{ background: '#ffebee', padding: '1.5rem', borderRadius: '10px', borderLeft: '4px solid #f44336' }}>
                <h2>🚨 Acil Durum Destek</h2>
                <div style={{ background: '#fff', padding: '1.5rem', borderRadius: '8px', marginTop: '1rem' }}>
                  <h3>📞 Acil Durum Hattı</h3>
                  <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#f44336' }}>
                    08502428876
                  </p>
                  <p>7/24 Hizmet • Anında Müdahale</p>
                  
                  <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8f9fa', borderRadius: '5px' }}>
                    <h4>🛡️ Güvenlik Önlemleri</h4>
                    <ul style={{ marginLeft: '1rem' }}>
                      <li>Tüm araçlarda GPS takip sistemi</li>
                      <li>Şoför kimlik doğrulama</li>
                      <li>Yolculuk kayıt sistemi</li>
                      <li>SOS butonu (yakında)</li>
                    </ul>
                  </div>

                  <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#e3f2fd', borderRadius: '5px' }}>
                    <h4>🚔 Acil Durumda Yapılacaklar</h4>
                    <ol style={{ marginLeft: '1rem' }}>
                      <li>Önce 112 Acil Servisi arayın</li>
                      <li>Taxicim Acil Hattını arayın: 08502428876</li>
                      <li>Konum bilginizi paylaşın</li>
                      <li>Yolculuk detaylarını bildirin</li>
                    </ol>
                  </div>
                </div>
              </section>
            </div>
          )}
        </div>

        <div style={{ 
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)', 
          padding: '3rem', 
          borderRadius: '25px', 
          marginTop: '3rem', 
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e8e8e8'
        }}>
          <h3 style={{ 
            fontSize: '1.8rem', 
            marginBottom: '2rem', 
            color: '#333',
            fontWeight: '700'
          }}>🤝 Size Nasıl Yardımcı Olabiliriz?</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>
            {supportCategories.map(category => (
              <div 
                key={category.id}
                style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                  padding: '2rem 1.5rem',
                  borderRadius: '20px',
                  border: '2px solid #e8e8e8',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)'
                }}
                onClick={() => {
                  setActiveTab('contact');
                  setContactForm(prev => ({ ...prev, category: category.name }));
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                  e.currentTarget.style.borderColor = '#FFC107';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.08)';
                  e.currentTarget.style.borderColor = '#e8e8e8';
                }}
              >
                <div style={{ 
                  fontSize: '3rem', 
                  marginBottom: '1rem',
                  filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
                }}>{category.icon}</div>
                <div style={{ 
                  fontWeight: '700', 
                  fontSize: '1.1rem',
                  color: '#333'
                }}>{category.name}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '2rem', color: '#666' }}>
          <p>© 2025 Taxicim. Müşteri memnuniyeti önceliğimizdir.</p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage; 